import { Button, Card, Panel } from '@/components/Bicester';
import { Form } from '@/components/formik-rsuite';
import { useRequest } from 'ahooks';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import { defaultLuggageInfo, luggageSchema } from './constants';
import { SiteContext } from '..';
import Toolbar from '../components/Toolbar';
import { fetchAddEditLuggage } from '@/services/site/luggage';
import { LEVEL_TYPE } from '@/constants';
import { Alert } from 'rsuite';
import { push } from '@/utils/history';

const Luggage = () => {
  const { member } = React.useContext(SiteContext);

  const { run: addEditLuggage, loading: addEditLuggageLoading } = useRequest(fetchAddEditLuggage, {
    manual: true,
  });

  const formik = useFormik({
    initialValues: defaultLuggageInfo,
    validationSchema: luggageSchema,
    onSubmit(values, actions) {
      const data = Object.assign({}, values, {
        [member?.level === LEVEL_TYPE.NOT ? 'not_member_id' : 'member_id']: member?.id,
      });
      addEditLuggage(data)
        .then((res) => {
          if (res?.id) {
            const { id } = res;
            Alert.success(res?.msg ?? '保存成功');
            push(`/site-service/record/info/luggage/${id}`);
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form guard>
        <Panel
          title="行李寄存"
          leftShadow
          style={{
            height:
              'calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight) - 195px)',
          }}
          toolbar={<Toolbar handleReset={formik.resetForm} />}
          loading={addEditLuggageLoading}
        >
          <Card smDivider>
            <div className="w-[50%]">
              <div className="flex">
                <Card.Input required label="寄存件数" inputType="number" formKey="number" />
                <Card.Input required label="行李牌号" formKey="luggage_code" />
              </div>
              <Card.Input label="备注" formKey="remark" labelWeight={1} contentWeight={3} />
            </div>
          </Card>
          <div className="flex justify-end">
            <Button type="submit" className="px-[70px]">
              确认提交
            </Button>
          </div>
        </Panel>
      </Form>
    </FormikProvider>
  );
};

export default Luggage;
